import { apiClient, API_PRX } from '@indipia/shared';

/** 추천 카드 (mode=RECOMMEND 일 때) — advisor GreetingResponse.recommend */
export interface RecommendCard {
  agentId: number;
  agentCode?: string | null;
  title?: string | null;
  description?: string | null;
  iconUrl?: string | null;
}

/** 인사말 응답 — advisor GreetingResponse (indipia 가 data 로 통과) */
export interface GreetingData {
  message: string;
  mode: 'WEATHER' | 'RECOMMEND';
  recommend?: RecommendCard | null;
  weather?: {
    sky?: string | null;
    precipitation?: string | null;
    temperature?: number | null;
  } | null;
  location?: { latitude?: number; longitude?: number } | null;
}

/**
 * 인사말 조회 — FE → FlowGate → sv-indipia → sv-advisor.
 * 위치는 선택(미전달 시 시간대 인사말). compId·userId 는 FlowGate 가 JWT 에서 주입.
 */
export async function fetchGreeting(params?: {
  latitude?: number;
  longitude?: number;
}): Promise<GreetingData> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/studio/greeting`, { params });
  return res.data.data as GreetingData;
}
